// src/pages/Customers.js
import React, { useEffect, useState } from "react";
import Pagination from "../components/Customer/Pagination.js";
import CustomersSummary from "../components/Customer/CustomersSummary.js";
import AddCustomerModal from "../components/CustomersMainPage/AddCustomerModal.js";
import api from "../services/api.js";

export default function Customer({ role }) {
  const token = localStorage.getItem("token");

  const [customers, setCustomers] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [params, setParams] = useState({
    page: 1,
    limit: 100,
    search: "",
    status: "",
  });

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/customers`, { params });
      setCustomers(data.data);
      setMeta(data.meta);
    } catch (err) {
      console.error("Fetch customers failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
    // eslint-disable-next-line
  }, [params.page, params.limit, params.search, params.status]);

  return (
    <div className="p-5">
      <h2 className="text-xl font-semibold mb-4 text-gray-800 dark:text-gray-100">
        Customers
      </h2>

      {/* SUMMARY */}
      <CustomersSummary meta={meta} />

      {/* FILTER */}
      <div className="flex flex-wrap gap-3 mb-4">
        <input
          type="text"
          placeholder="Search name / ID / email"
          value={params.search}
          onChange={(e) =>
            setParams({ ...params, page: 1, search: e.target.value })
          }
          className="px-3 py-2 rounded-lg border bg-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
        />

        <select
          value={params.status}
          onChange={(e) =>
            setParams({ ...params, page: 1, status: e.target.value })
          }
          className="px-3 py-2 rounded-lg border bg-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
        >
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="suspended">Suspended</option>
          <option value="closed">Closed</option>
          <option value="terminated">Terminated</option>
        </select>

        {role === "billing" && (
          <button
            onClick={() => setOpenModal(true)}
            className="bg-blue-600 text-white px-4 py-2 ml-auto rounded"
          >
            + Tambah Customer
          </button>
        )}
      </div>

      {/* TABLE */}
      <div className="overflow-x-auto rounded-xl shadow bg-white dark:bg-gray-800">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 dark:bg-gray-700">
            <tr>
              <th className="px-4 py-3 text-left">Customer ID</th>
              <th className="px-4 py-3 text-left">Full Name</th>
              <th className="px-4 py-3 text-left">Email</th>
              <th className="px-4 py-3 text-left">Phone</th>
              <th className="px-4 py-3 text-left">Status</th>
              <th className="px-4 py-3 text-left">Created</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="px-4 py-6 text-center text-gray-500">
                  Loading...
                </td>
              </tr>
            ) : customers.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-6 text-center text-gray-500">
                  No data found
                </td>
              </tr>
            ) : (
              customers.map((cust) => (
                <tr
                  key={cust.id}
                  onClick={() =>
                    (window.location.href = `/customer-detail/${cust.id}`)
                  }
                  className="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition"
                >
                  <td className="px-4 py-3 font-medium">{cust.customer_id}</td>
                  <td className="px-4 py-3">{cust.full_name}</td>
                  <td className="px-4 py-3">{cust.email || "-"}</td>
                  <td className="px-4 py-3">{cust.phone_number || "-"}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`px-2 py-1 rounded text-xs font-semibold
                        ${
                          cust.status === "active"
                            ? "bg-green-600 text-white"
                            : cust.status === "suspended"
                            ? "bg-yellow-500 text-black"
                            : cust.status === "inactive"
                            ? "bg-gray-500 text-white"
                            : "bg-red-600 text-white"
                        }`}
                    >
                      {cust.status}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    {new Date(cust.created_at).toLocaleDateString("id-ID")}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      <AddCustomerModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        token={token}
        onSuccess={fetchCustomers}
      />

      {/* PAGINATION */}
      {meta.totalPages > 1 && (
        <Pagination
          currentPage={meta.page}
          totalPages={meta.totalPages}
          onPageChange={(page) => setParams({ ...params, page })}
        />
      )}
    </div>
  );
}
